<template>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M28.6904 1.21488C30.5997 -0.404961 33.4005 -0.404961 35.3096 1.21488L60.8874 22.9171C62.0329 23.889 62.6931 25.3154 62.6931 26.8177V58.8845C62.6931 61.7096 60.4027 64 57.5775 64H37.9681C36.5556 64 35.4104 62.8548 35.4104 61.4421V40.1274H28.5897V61.4421C28.5897 62.8548 27.4446 64 26.0319 64H6.42246C3.59723 64 1.30693 61.7096 1.30693 58.8845V26.8177C1.30693 25.3154 1.9673 23.889 3.11281 22.9171L28.6904 1.21488ZM32.0001 5.11553L6.42246 26.8177V58.8845H23.4742V37.5698C23.4742 36.1571 24.6193 35.0119 26.0319 35.0119H37.9681C39.3808 35.0119 40.526 36.1571 40.526 37.5698V58.8845H57.5775V26.8177L32.0001 5.11553Z"
  />
</template>
